module.exports = __webpack_public_path__ + "static/media/kangyang-7@2x.76afe03a.png";